class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.minusBtn = this.querySelector('[name="minus"]');
    this.plusBtn = this.querySelector('[name="plus"]');
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.originalMaxInventory = parseInt(this.input?.max) || 999999;
    this.cartQuantity = 0;
    
    console.log('Quantity Input Initialized');
    
    // CRITICAL: Force value to 1 if it's 0
    if (this.input) {
      const currentValue = parseInt(this.input.value);
      if (currentValue === 0 || isNaN(currentValue) || currentValue < 1) {
        console.log('Fixing initial value to 1');
        this.input.value = 1;
      }
      // Initially disable minus button since value is 1
      if (this.minusBtn) {
        this.minusBtn.disabled = true;
      }
    }
    
    this.bindEvents();
    
    // Listen for cart updates
    document.addEventListener('cart:updated', this.onCartUpdate.bind(this));
    document.addEventListener('ajaxcart:updated', this.onCartUpdate.bind(this));
    document.addEventListener('cart-updated', this.onCartUpdate.bind(this));
    
    // Update button states after everything loads
    setTimeout(() => this.updateButtonStates(), 100);
    setTimeout(() => this.updateButtonStates(), 500);
  }

  bindEvents() {
    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.input.addEventListener('input', this.onInputInput.bind(this));
    }
    
    if (this.minusBtn) {
      this.minusBtn.addEventListener('click', this.decrement.bind(this));
    }
    
    if (this.plusBtn) {
      this.plusBtn.addEventListener('click', this.increment.bind(this));
    }
    
    document.addEventListener('variant:changed', this.onVariantChange.bind(this));
  }

  onInputChange(event) {
    this.validateValue();
  }

  onInputInput(event) {
    this.validateValue();
  }

  validateValue() {
    let value = parseInt(this.input.value);
    const min = 1;
    const max = parseInt(this.input.max) || 999999;
    
    if (isNaN(value) || value < min) {
      value = min;
    } else if (value > max) {
      value = max;
    }
    
    this.input.value = value;
    this.updateButtonStates();
  }

  decrement() {
    const currentValue = parseInt(this.input.value) || 1;
    const step = parseInt(this.input.step) || 1;
    const newValue = currentValue - step;
    
    if (newValue >= 1) {
      this.input.value = newValue;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.updateButtonStates();
    }
  }

  increment() {
    const currentValue = parseInt(this.input.value) || 1;
    const step = parseInt(this.input.step) || 1;
    const newValue = currentValue + step;
    const maxInventory = parseInt(this.input.max) || 999999;
    
    if (newValue <= maxInventory) {
      this.input.value = newValue;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.updateButtonStates();
    }
  }

  onVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant) return;
    
    this.originalMaxInventory = variant.inventory_quantity || 999999;
    this.input.max = this.originalMaxInventory;
    this.input.dataset.max = this.originalMaxInventory;
    
    const cartQuantity = event.detail.cartQuantity || 0;
    this.cartQuantity = cartQuantity;
    
    // IMPORTANT: Always show at least 1, never 0
    if (cartQuantity > 0) {
      this.input.value = cartQuantity;
    } else {
      this.input.value = 1;
    }
    
    this.updateButtonStates();
  }
  
  onCartUpdate(event) {
    console.log('Cart updated');
    
    const variantId = this.input.dataset.quantityVariantId;
    
    // Get cart items from different possible structures
    let cartItems = [];
    if (event.detail.cart?.items) {
      cartItems = event.detail.cart.items;
    } else if (event.detail.items) {
      cartItems = event.detail.items;
    } else if (event.detail.data?.items) {
      cartItems = event.detail.data.items;
    }
    
    const cartItem = cartItems.find(item => item.variant_id == variantId);
    
    if (cartItem) {
      console.log('Found in cart:', cartItem.quantity);
      this.cartQuantity = cartItem.quantity;
      this.input.value = cartItem.quantity;
    } else {
      console.log('Not in cart, resetting to 1');
      this.cartQuantity = 0;
      this.input.value = 1;
    }
    
    this.input.max = this.originalMaxInventory;
    this.updateButtonStates();
  }

  updateButtonStates() {
    const currentValue = parseInt(this.input.value) || 1;
    const maxInventory = parseInt(this.input.max) || 999999;
    
    console.log('Updating buttons - Value:', currentValue, 'Max:', maxInventory);
    
    // Minus button: ENABLED when value > 1
    if (this.minusBtn) {
      this.minusBtn.disabled = currentValue <= 1;
    }
    
    // Plus button: ENABLED when value < max
    if (this.plusBtn) {
      this.plusBtn.disabled = currentValue >= maxInventory;
    }
  }

  disconnectedCallback() {
    document.removeEventListener('variant:changed', this.onVariantChange);
    document.removeEventListener('cart:updated', this.onCartUpdate);
    document.removeEventListener('ajaxcart:updated', this.onCartUpdate);
    document.removeEventListener('cart-updated', this.onCartUpdate);
  }
}

// Register component
if (!customElements.get('m-quantity-input')) {
  customElements.define('m-quantity-input', QuantityInput);
}

// FINAL SAFETY CHECK - Runs every 200ms to ensure no 0 values and correct button states
setInterval(function() {
  document.querySelectorAll('m-quantity-input').forEach(component => {
    const input = component.querySelector('input');
    const minusBtn = component.querySelector('[name="minus"]');
    const plusBtn = component.querySelector('[name="plus"]');
    
    if (input) {
      const currentValue = parseInt(input.value);
      const maxValue = parseInt(input.max) || 999999;
      
      // SAFETY 1: Never allow 0
      if (currentValue === 0 || isNaN(currentValue) || currentValue < 1) {
        console.log('SAFETY: Fixing 0 to 1');
        input.value = 1;
      }
      
      // SAFETY 2: Correct minus button state
      if (minusBtn) {
        const newValue = parseInt(input.value) || 1;
        minusBtn.disabled = newValue <= 1;
      }
      
      // SAFETY 3: Correct plus button state
      if (plusBtn) {
        const newValue = parseInt(input.value) || 1;
        plusBtn.disabled = newValue >= maxValue;
      }
    }
  });
}, 200);